import { Chip } from "@material-ui/core";
import { InfoOutlined } from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import { SelectInput, required } from "react-admin";
import { GetRbhRemoveReasonType, RbhRemoveReasonType } from "../../../../Enums/RbhRemoveReasonType";
import { GetRbhRemoveReasonSubType, UnscheduledRemoveReasonSubType } from "../../../../Enums/RemoveReasonSubType";
const RemoveReasonSubType = props => {
  const [removeReasonType, setRemoveReasonType] = useState();
  const [removeReasonSubType, setRemoveReasonSubType] = useState();

  useEffect(() => {
    setRemoveReasonType(props.removeReasonType);
    setRemoveReasonSubType(props.removeReasonSubType);
  }, [props]);

  const removeReasonChange = e => {
    setRemoveReasonType(e.target.value);
  };

  const removeReasonSubTypeChange = e => {
    setRemoveReasonSubType(e.target.value);
  };

  return (
    <>
      <SelectInput
        source="removeReasonType"
        label="Remove Reason Type"
        choices={GetRbhRemoveReasonType}
        optionText="Description"
        optionValue="Value"
        fullWidth
        variant="outlined"
        validate={required()}
        defaultValue={removeReasonType}
        onChange={e => removeReasonChange(e)}
        disabled={props.isDisabled}
      />
      {GetRbhRemoveReasonSubType(removeReasonType) && (
        <SelectInput
          source="removeReasonSubType"
          label="Remove Reason Sub Type"
          choices={GetRbhRemoveReasonSubType(removeReasonType)}
          optionText="Description"
          optionValue="Value"
          fullWidth
          variant="outlined"
          defaultValue={removeReasonSubType}
          onChange={e => removeReasonSubTypeChange(e)}
          disabled={props.isDisabled}
        />
      )}
      {!props.isDisabled &&
        removeReasonType == RbhRemoveReasonType.Unscheduled &&
        (removeReasonSubType == UnscheduledRemoveReasonSubType.FailOnFit ||
          removeReasonSubType === UnscheduledRemoveReasonSubType.PrematureFailure ||
          removeReasonSubType === UnscheduledRemoveReasonSubType.INOP) && (
          <>
            <Chip
              key={9999990}
              color="primary"
              variant="outlined"
              label={
                removeReasonSubType == UnscheduledRemoveReasonSubType.FailOnFit
                  ? "Please Upload US TAG for Unserviceable Fail On Fit Requests!"
                  : removeReasonSubType === UnscheduledRemoveReasonSubType.INOP
                  ? "Please Upload US TAG for Unserviceable INOP Requests!"
                  : "Please Upload US TAG for Unserviceable Premature Failure Requests!"
              }
              icon={<InfoOutlined />}
            />
            <Chip
              key={9999981}
              color="primary"
              variant="outlined"
              label={
                removeReasonSubType == UnscheduledRemoveReasonSubType.FailOnFit
                  ? "Removal reason was selected as Unscheduled - Fail On Fit, TSI hour input must be 0."
                  : removeReasonSubType === UnscheduledRemoveReasonSubType.INOP
                  ? "Removal reason was selected as Unscheduled - INOP, TSI hour cannot be 0 and must be less than 500 FH."
                  : "Removal reason was selected as Unscheduled - Premature, TSI hour cannot be 0 and must be less than 500 FH."
              }
              icon={<InfoOutlined />}
            />
          </>
        )}
      {!props.isDisabled && removeReasonType == RbhRemoveReasonType.ServiceableReturn && (
        <>
          <Chip
            key={9999990}
            color="primary"
            variant="outlined"
            label={"You must upload unused statement file"}
            icon={<InfoOutlined />}
          />
        </>
      )}
    </>
  );
};

export default RemoveReasonSubType;
